export default function isSingleChoiceCorrect(answers: Array<Record<string, string>>) {
  const arr = answers.filter((answer: Record<string, any>) => (answer.checked === true && answer.correct === true));
  // if single choice answer has more than one correct answer and one is checked retrun true
  return arr.length > 0; // true or false
}
